import { render, staticRenderFns } from "./UsageDashboard.vue?vue&type=template&id=265c29cc&scoped=true"
import script from "./UsageDashboard.vue?vue&type=script&lang=js"
export * from "./UsageDashboard.vue?vue&type=script&lang=js"
import style0 from "./UsageDashboard.vue?vue&type=style&index=0&id=265c29cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c29cc",
  null
  
)

export default component.exports